import styled from 'styled-components';

export const CheckmarkContainer = styled.div`
  align-items: center;
  border-radius: 50%;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const ExpandableStepBadge = styled.div<{ status: string }>`
  background: #d8dce2;
  border: 1px solid #aab5c5;
  border-radius: 50%;
  flex: 0 0 auto;
  height: 30px;
  margin-right: 24px;
  width: 30px;

  span {
    color: #8c98a8;
    display: block;
    font-weight: bold;
    font-size: 13px;
    line-height: 18px;
    margin: 5px 0;
    text-align: center;
  }

  ${({ status }) => {
    if (status === 'complete') {
      return `
      background: #4ca667;
      border-color: #4ca667;
    `;
    }
    if (status === 'current') {
      return `
      background: #0b99e6;
      border-color: #3d85c9;

      span { color: #fff; }
    `;
    }
    return null;
  }}
`;

export const ExpandableStepContent = styled.div<{ expanded: boolean }>`
  border-radius: 0 0 9px 9px;
  height: 0;
  overflow: hidden;

  ${({ expanded }) =>
    expanded &&
    `
    height: auto;
    overflow: visible;
    padding: 40px;
  `}
`;

export const ExpandableStepDescription = styled.div`
  color: #717478;
  font-size: 13px;
  line-height: 18px;
`;

export const ExpandableStepEdit = styled.div<{ disabled: boolean }>`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  span {
    color: #a2a6aa;
    font-weight: bold;
    font-size: 14px;
    line-height: 175%;
    margin-left: 8px;
  }
`;

export const ExpandableStepHeader = styled.div<{ status: string; disabled: boolean; expanded: boolean }>`
  align-items: center;
  background: ${({ status }) => (status === 'complete' ? '#fff' : '#f0f3f6')};
  border-bottom: 1px solid #cdd2d7;
  border-radius: 8px 8px 0 0;
  display: flex;
  padding: 24px 30px;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};

  ${({ expanded }) =>
    !expanded &&
    `
    border-bottom: none;
    border-radius: 9px;
  `}
`;

export const ExpandableStepLabels = styled.div`
  flex: 1 1 auto;
`;

export const ExpandableStepTitle = styled.div`
  color: #46494c;
  font-weight: bold;
  font-size: 18px;
  line-height: ${20 / 18};
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ExpandableStepWrapper = styled.div<{ expanded: boolean }>`
  background: #ffffff;
  border: 1px solid #cdd2d7;
  box-shadow: ${({ expanded }) => (expanded ? '0 4px 3px rgba(0, 0, 0, 0.0530741)' : 'none')};
  border-radius: 9px;
  margin-bottom: 25px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;
